'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationForms', ['$scope', '$stateParams', 'FBForms', 'FBPackages', '$q', '$state', 'LicenseRequestFBResponses', 'Triggers', function ($scope, $stateParams, FBForms, FBPackages, $q, $state, LicenseRequestFBResponses, Triggers) {
        $scope.resetApplication();
        $scope.licenseID = $stateParams.licenseID;
        $scope.loading = true;
        $scope.saving = false;
        
        var promises = [];

        if ($stateParams.licenseID != null) {
            promises.push(FBForms.get({ license_id: $stateParams.licenseID }).then(function (forms) {
                $scope.forms = forms;
            }));
        
            promises.push(FBPackages.get({ license_id: $stateParams.licenseID }).then(function (packages) {
                $scope.packages = packages;
            }));

            $scope.getApplication();
        }
        else {
            $state.go('internal.licensing.application.responses', { id: $scope.applicationID });
        }

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });;

        $scope.addForm = function (form) {
            $scope.saving = true;

            LicenseRequestFBResponses.save({ license_request_id: $scope.applicationID }, form.id).then(function () {
                $scope.getApplication();
                $scope.saving = false;
            })
        }

        $scope.addPackage = function (form_package) {
            $scope.saving = true;
            var promises = [];
            var due_on = null;
            if (form_package.due_on_value != null && form_package.due_on_value > 0) {
                due_on = new Date();
                due_on.setHours(due_on.getHours() + form_package.due_on_value);
            }

            if (form_package.attach_trigger_id != null && form_package.attach_trigger_name != null) {
                promises.push(Triggers.fire({
                    name: form_package.attach_trigger_name,
                    triggerID: form_package.attach_trigger_id,
                    licenseRequestID: $scope.applicationID
                }))
            }

            form_package.forms.forEach(function (form) {
                var found = false;
                $scope.application.responses.forEach(function (response) {
                    if (response.form_id == form.id) {
                        found = true;
                        promises.push(LicenseRequestFBResponses.save({
                            id: response.license_request_response_id,
                            response_id: response.id,
                            package_id: form_package.id,
                            license_request_id: $scope.applicationID,
                            due_on: due_on
                        }, form.id))
                    }
                })
                if (!found) {
                    promises.push(LicenseRequestFBResponses.save({
                        package_id: form_package.id,
                        license_request_id: $scope.applicationID,
                        due_on: due_on
                    }, form.id))
                }
            })

            $q.all(promises).then(function () {
                $scope.getApplication();
                $scope.saving = false;
            }).catch(function (response) {
                // handle error
            });;
        }

        $scope.addPackageForm = function (form_package, form) {
            $scope.saving = true;
            var due_on = null;
            if (form_package.due_on_value != null && form_package.due_on_value > 0) {
                due_on = new Date();
                due_on.setHours(due_on.getHours() + form_package.due_on_value);
            }

            LicenseRequestFBResponses.save({ package_id: form_package.id, license_request_id: $scope.applicationID, due_on: due_on }, form.id).then(function () {
                $scope.getApplication();
                $scope.saving = false;
            })
        }

        $scope.showForm = function (form) {
            var show = true;
            form.show = true;

            if ($scope.application != null) {
                $scope.application.responses.forEach(function (response) {
                    if (response.form_id == form.id) {
                        show = false;
                    }
                })

                form.packages.forEach(function (form_package) {
                    $scope.application.packages.forEach(function (response_package) {
                        if (form_package.id == response_package.id) {
                            show = false;
                        }
                    })
                })
            }

            form.show = show;
            return show;
        }

        $scope.showPackage = function (form_package) {
            var hasPackage = false;
            var hasAllForms = true;
            form_package.show = true;

            if ($scope.application != null) {
                form_package.canAdd = true;
                $scope.application.packages.forEach(function (response_package) {
                    if (form_package.id == response_package.id) {
                        hasPackage = true;
                        form_package.canAdd = false;
                        form_package.forms.forEach(function (form) {
                            form.canAdd = true;
                            response_package.responses.forEach(function (response) {
                                if (response.form_id == form.id) {
                                    form.canAdd = false;
                                }
                            })
                            if (form.canAdd) {
                                hasAllForms = false;
                            }
                        })
                    }
                })
            }

            form_package.show = !hasPackage || !hasAllForms;
            return !hasPackage || !hasAllForms;
        }

        $scope.anyPackages = function (packages) {
            var any = false;

            packages.forEach(function (form_package) {
                if (form_package.show) {
                    any = true;
                }
            })

            return any
        }

        $scope.anyForms = function (forms) {
            var any = false;

            forms.forEach(function (form) {
                if (form.show) {
                    any = true;
                }
            })

            return any
        }
    }])
;